const parseCartItemErrors = cart_item_errors => {
  let issue;
  let issueType;
  if (cart_item_errors) {
    const { stockValidation, ...otherErrors } = cart_item_errors;
    if (stockValidation) {
      const issueValues = Object.values(stockValidation);
      if (issueValues && issueValues[0]) {
        issueType = 'OUT_OF_STOCK';
        const issueValue = issueValues[0];
        issue = issueValue;
      }
    } else if (otherErrors) {
      const firstErrorKey = Object.keys(otherErrors)[0];
      if (otherErrors[firstErrorKey]) {
        const issueValues = Object.values(otherErrors[firstErrorKey]);
        issueType = 'UNAVAILABLE';
        issue = issueValues?.[0]
          ? issueValues[0]
          : 'The product is not available at the moment.';
      }
    }
  }
  return { issue, issueType };
};

export default parseCartItemErrors;
